(() => {
  class MedicationSearchController {
    constructor(MedicationService) {
      'ngInject';

      Object.assign(this, {
        MedicationService
      });
    }

    onTextChange(query) {
      if (!query || query.length < 3) {
        return [];
      }

      return this.MedicationService.searchDosespotMedications(query).then(({
        data
      }) => {
        return data.map(med => {
          return {
            name: med
          };
        });
      });
    }

    selectMedication(medication) {
      this.onMedicationSelect({
        medication
      });
    }

  }

  MedicationSearchController.$inject = ["MedicationService"];
  angular.module('pims').component('medicationSearch', {
    templateUrl: 'app/components/medication-search/medication-search.html',
    controller: MedicationSearchController,
    bindings: {
      selectedItem: '<',
      onMedicationSelect: '&'
    }
  });
})();